<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">The Real Plan Calculator</h1>
        <h2 class="subtitle">Sometimes Plan B is really Plan A</h2>
        <p>
          <a href="https://www.realplancalc.com">www.realplancalc.com</a>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {};
  },
};
</script>

<style scoped>
section {
  background-color: #3f3f3f;
  color: #fff;
}
h1,
h2 {
  color: #fff;
}
a {
  color: aquamarine;
}
</style>